export const isProduction = process.env.NODE_ENV === 'production';

// SMTP
// for production or real SMTP
export const SMTP_HOST = 'smtp.gmail.com';
export const SMTP_PORT = 465;
export const SMTP_USER = 'mpiredm@gmail.com';
export const SMTP_PASS = 'zfjh zclm mmie czog';

// the “to” address for contact form
export const CONTACT_TO = 'mikepeters011@gmail.com';

// Brand
export const companyName = 'iSolvents';
export const companyFriendly = 'iSolvents';

// Logos
export const logosMediaSrc = 'file' // fiel | component
export const logoAltText = `Welcome to ${companyName}`

export const logoLight = '/logo_light.svg'; // component name if logosMediaType is component
export const logoDark = '/logo_dark.svg'; // component name if logosMediaType is component
export const logoFixedLight = '/logo_light.svg'; // component name if logosMediaType is component
export const logoFixedDark = '/logo_dark.svg'; // component name if logosMediaType is component

// Header
export const headerContainerHeight = '100px';
export const headerContainerHeightFixed = '65px';

// Page Functional
export const appTitle = 'iSolvents';
export const appDescription = 'Solvents Simplified';

export const siteLogo = '/logo.png';
export const siteLogoWidth = 120;
export const siteLogoHeight = 120;

export const siteUrl = 'https://iSolvents.group';
export const siteImage = `${siteUrl}/images/iSolvents-group.png`;
export const copyrightCompany = 'iSolvents (PTY) LTD'
export const copyrightYear = '2025'



// Specific Components and Functionality


// IO Header
// When the site loads, without scrolling what is the height of the desktop header

export const ioHeader = {
  heightDefault: '100px',
  heightFixed: '65px',
  heightFixedMini: '65px', //  Fixed mini is when the header sticks for a distance but then gets smaller beyond the hero for example (later)

  // When the header should be fixed
  headerFixedTriggerType: "value", // | "element"
  headerFixedTriggerHeight: 100, // can be 100 or 100px, we need to check for string or numbers, numbers are assumed to be pixels
  headerFixedTriggerElementSelector: '' //  if element is used, this is the selector for the element
}


export const ioHeroDefaults = {
  
}


// Mega Menu
export const megaMenuThemeClass = '' // Parent class for styling, leave black for default
export const megaTabComponentsPath = '/components/io/io-mega-menu/tabs/'
export const megaMenuItems = [
  {
    label: 'Home',
    name: 'home',
    routePath: '/',
    mega: false,
    // Active states
    activeRouteName: 'index',
    activeRouteContainsName: true

  },
  {
    label: 'About',
    name: 'about',
    routePath: '/',

    mega: true,
    component: 'MegaAbout',
    // Active states
    activeRouteName: 'our-service',
    activeRouteContainsName: true,
    megaStyles: {}
  },
  {
    label: 'Solutions',
    name: 'solutions',
    routePath: '/',
    mega: true,
    component: 'MegaSolutions',
    // Active states
    activeRouteName: 'solutions',
    activeRouteContainsName: true
  },
  {
    label: 'Products',
    name: 'products',
    routePath: '/',
    mega: false,
    component: 'MegaProducts',
    // Active states
    activeRouteName: 'product',
    activeRouteContainsName: true
  },
  {
    label: 'Media',
    name: 'media',
    routePath: '/',
    mega: true,
    component: 'MegaMedia',
    // Active states
    activeRouteName: 'blog',
    activeRouteContainsName: true
  },
]


export const mobileNavigationItems = [
  {
    label: 'Home',
    name: 'home',
    routePath: '/',
    // Active states
    activeRouteName: 'index',
    activeRouteContainsName: false,
    type: 'route'

  },
  {
    label: 'About',
    name: 'about-us',
    routePath: '/about-us',
    // Active states
    activeRouteName: 'about-us',
    activeRouteContainsName: false,
    type: 'route'
  },
  {
    label: '360 Service',
    name: 'our-service',
    routePath: '/our-service',
    // Active states
    activeRouteName: 'our-service',
    activeRouteContainsName: false,
    type: 'route',
    children: [
      {
        label: 'Discovery Assessment',
        name: 'discovery-assessment',
        routePath: '/our-service?discovery',
      },
      {
        label: 'Solution Development',
        name: 'solution-development',
        routePath: '/our-service?solution',
      },
      {
        label: 'Implementation',
        name: 'implementation',
        routePath: '/our-service?implementation',
      },
      {
        label: 'Support & Waste Management',
        name: 'support-waste-management',
        routePath: '/our-service?support',
      },
      {
        label: 'Continuous Refinement',
        name: 'continuous-refinement',
        routePath: '/our-service?refine',
      }

    ]
  },

  {
    label: 'Chemistry',
    name: 'chemistry',
    routePath: '/solutions/ethanol-blending',
    // Active states
    activeRouteName: 'solutions-ethanol-blending',
    activeRouteContainsName: false,
    type: 'route',
    children: [
      {
        label: 'Tailored Ethanol Blending',
        name: 'solutions-ethanol-blending',
        routePath: '/solutions/ethanol-blending',
      },
      {
        label: 'Essential Chemicals',
        name: 'solutions-essential-chemicals',
        routePath: '/solutions/essential-chemicals',
      },
      {
        label: 'Manufactured Products',
        name: 'solutions-manufactured-products',
        routePath: '/solutions/manufactured-products',
      }
    ]
  },
  {
    label: 'Services',
    name: 'services',
    routePath: '/solutions/manufacturing-as-a-service',
    // Active states
    activeRouteName: 'solutions-manufacturing-as-a-service',
    activeRouteContainsName: false,
    type: 'route',
    children: [
      {
        label: 'Manufacturing as a Service',
        name: 'solutions-manufacturing-as-a-service',
        routePath: '/solutions/manufacturing-as-a-service',
      },
      // {
      //   label: 'Hazardous Waste Solutions',
      //   name: 'solutions-hazardous-waste-solutions',
      //   routePath: '/solutions/hazardous-waste-solutions',
      // }
    ]
  },
  {
    label: 'Industries & Applications',
    name: 'industries-applications',
    routePath: '/industries',
    // Active states
    activeRouteName: 'industries',
    activeRouteContainsName: false,
    type: 'route',
    children: [
      {
        label: 'Industry Specific Solutions',
        name: 'industries',
        routePath: '/industries',
      },
      {
        label: 'Applications',
        name: 'applications',
        routePath: '/applications',
      }
    ]
  },
  {
    label: 'Products',
    name: 'products',
    routePath: '/products',
    // Active states
    activeRouteName: 'products',
    activeRouteContainsName: false,
    type: 'route',
  },
  {
    label: 'Contact Us',
    name: 'contact-us',
    routePath: '/contact-us',
    // Active states
    activeRouteName: 'contact-us',
    activeRouteContainsName: false,
    type: 'route',
  }
]

// The point at which the mobile menu turns in the desktop menu
export const mobileMenuSnapPoint = 1200; // needs to be a number
